import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../template/_common/header";
import SidebarComponent from "../template/superadmin/sidebarComponent";
import SidebarArrow from "../template/_common/sidebarArrow";
import { globalAlert, globalLoader } from "../actions/commonActions";
import {

  viewOrgApi,
  editOrgApi,
  editOrgZoneApi,
  editOrgConfigApi,
} from "./_actions";
import { logOut } from "../_shared/commonFunction";
import { Helmet } from "react-helmet";
import { withRouter } from "../_shared/withRouter";

import EditBrandInfo from "../template/superadmin/editBrandInfo";
import EditAreaCode from "../template/superadmin/editAreaCode";
import EditZones from "../template/superadmin/editZones";
import EditConfig from "../template/superadmin/editConfig";

const EditOrganisations = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [activeTab, setActiveTab] = useState("brand");

  const [orgData, setOrgData] = useState({});
  const [allowView, setAllowView] = useState(true);
  const [lmsServerError, setLmsServerError] = useState("");

  const [id, setId] = useState("");

  const handleSidebar = (data) => {
    setNavbarToggle(data);
  };
  useEffect(() => {
    callBasicApi(); // eslint-disable-next-line
  }, []);

  const callBasicApi = async () => {
    try {
      globalLoader(true);
      let pathName = window.location.pathname.split("/");
      pathName = pathName[pathName.length - 1];
      let res = await viewOrgApi(pathName);
      if (res?.data?.status === 200) {
        setId(pathName);
        setAllowView(true);
        setOrgData(res?.data?.data?.organization);
      } else {
        props.history.push("/superadmin/manage-organisations");
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/superadmin/login");
      }
      globalLoader(false);
    }
  };

  const valueSubmit = async (val) => {
    if (val) {
      globalLoader(true);
      setLmsServerError("");
      try {
        globalLoader(true);

        let res = await editOrgApi(val, id);
        if (res?.data?.status === 200) {
          globalAlert("success", res?.data?.message);
          // A short-name change on a live learner frontend returns data.warning —
          // surface it prominently so the admin knows shared links may break.
          const warning = res?.data?.data?.warning;
          if (warning) globalAlert("warning", warning);
          props.history.push("/superadmin/manage-organisations");
        } else {
          // Short-name soft errors (204) render inline on the brand tab; other
          // soft errors keep the global alert.
          const msg = res?.data?.message || "";
          if (/short name/i.test(msg)) {
            setLmsServerError(msg);
          } else {
            globalAlert("error", msg);
          }
        }
        globalLoader(false);
      } catch (error) {
        if (error?.response?.status === 401) {
          globalAlert("error", error?.response?.data?.message);
        } else {
          globalAlert("error", t("common.somethingWentWrong"));
        }
        globalLoader(false);
        logOut(props?.history, "/superadmin/login");
      }
    }
  };

  const changeNameSubmit= async (val) => {
    if (val) {
      globalLoader(true);
      try {
        

        let res = await editOrgZoneApi(val, id);
        if (res?.data?.status === 200) {
          globalAlert("success", res?.data?.message);
        } else {
          globalAlert("error", res?.data?.message);
        }
        globalLoader(false);
      } catch (error) {
        if (error?.response?.status === 401) {
          globalAlert("error", error?.response?.data?.message);
        } else {
          globalAlert("error", t("common.somethingWentWrong"));
        }
        globalLoader(false);
        logOut(props?.history, "/superadmin/login");
      }
    }
  };

  const changeConfigSubmit= async (val) => {
    if (val) {
      globalLoader(true);
      try {
        let res = await editOrgConfigApi(val, id);
        if (res?.data?.status === 200) {
          globalAlert("success", res?.data?.message);
        } else {
          globalAlert("error", res?.data?.message);
        }
        globalLoader(false);
      } catch (error) {
        if (error?.response?.status === 401) {
          globalAlert("error", error?.response?.data?.message);
        } else {
          globalAlert("error", t("common.somethingWentWrong"));
        }
        globalLoader(false);
        logOut(props?.history, "/superadmin/login");
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("superadmin.pageTitle.editOrganisation")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      {allowView && (
        <div className="admin-portal">
          <Header roleType="superadmin" />
          <div className={`${navbarToggle ? "active" : ""} wrapper`}>
            <SidebarComponent
              navbarToggle={navbarToggle}
              active={props.match.path}
              roleType={"superadmin"}
            />
            <div className="main">
              <div className="main-wrapper">
                <div>
                  <p className="admin-banner">
                    {t("superadmin.editOrg.title", { name: orgData?.orgName })}
                  </p>
                </div>
                <SidebarArrow handleSidebarToggle={handleSidebar} />
                <div className="px-3">
                  <ul className="tab-list pt-2 list-unstyled text-center">
                    <li
                      className={`${activeTab === "brand" ? "active" : ""
                        } d-inline-block`}
                      onClick={() => setActiveTab("brand")}
                    >
                      {t("superadmin.editOrg.tabBrandInfo")}
                    </li>
                    <li
                      className={`${activeTab === "area" ? "active" : ""
                        } d-inline-block`}
                      onClick={() => setActiveTab("area")}
                    >
                      {t("superadmin.editOrg.tabSectorCode")}
                    </li>
                    <li
                      className={`${activeTab === "zones" ? "active" : ""
                        } d-inline-block`}
                      onClick={() => setActiveTab("zones")}
                    >
                      {t("superadmin.editOrg.tabZones")}
                    </li>
                    <li
                      className={`${activeTab === "config" ? "active" : ""
                        } d-inline-block`}
                      onClick={() => setActiveTab("config")}
                    >
                      {t("superadmin.editOrg.tabConfig")}
                    </li>
                  </ul>
                  {activeTab === "brand" ? (
                    <EditBrandInfo
                      data={orgData}
                      valueSubmit={valueSubmit}
                      lmsServerError={lmsServerError}
                    />
                  ) : activeTab === "area"?
                    <EditAreaCode data={orgData} valueSubmit={valueSubmit} />
                     : activeTab === "zones"?
                    <EditZones data={orgData} valueSubmit={changeNameSubmit} />
                    :<EditConfig data={orgData} valueSubmit={changeConfigSubmit} />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(EditOrganisations);
